import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import LicensesPage from 'pages/Licenses/Licenses'
import LicensePreview from 'pages/Licenses/LicensePreview'
import LicenseCreate from 'pages/Licenses/LicenseCreate'
import LicenseEdit from 'pages/Licenses/LicenseEdit'
import { base_url } from 'env'

export const LicenseRoutes: RouteObject[] = [
  {
    path: '/licenses',
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/license/')
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/login')
      }
    },
    element: <LicensesPage />,
  },
  {
    path: '/license/:id',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(
          base_url + `/license/${params.id}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/login')
      }
    },
    element: <LicensePreview />,
  },
  {
    path: '/license/:id/edit',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/license/${params.id}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/login')
      }
    },
    element: <LicenseEdit />,
  },
  {
    path: '/license/',
    element: <LicenseCreate />,
  },
]
